var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'skeleton-categories',
    { 'skeleton-categories--mobile': _vm.$device && _vm.$device.isMobile } ]},_vm._l((_vm.skeletonCount),function(index){return _c('div',{key:index,staticClass:"skeleton-categories-item"},[_c('span',{staticClass:"skeleton-placeholder"},[_c('three-dots-loading')],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }